import { routes as pages } from '../app/pages'
const Login = () =>
    import( /* webpackChunkName: "auth" */ '@/app/auth/login/Login.vue')
const LoginResetPwd = () =>
    import( /* webpackChunkName: "auth" */ '@/app/auth/login/children/reset-pwd-module.vue')
const Home = () =>
    import( /* webpackChunkName: "auth" */ '../app/auth/home/home.vue')

export const routes = [

    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/loginResetPwd',
        name: 'LoginResetPwd',
        component: LoginResetPwd,
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        redirect: 'houselist',
        children: [
            ...pages
        ]
    },
]